import CheckIcon from '@mui/icons-material/Check';
import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@components';
import { useStore } from '@stores';
import { globalTheme as theme } from '@styles';
import { LanguageOptions } from '@types';

export const PassthroughParams = observer(() => {
  const { t, i18n } = useTranslation('subModules/contactInfo');

  const { featureFlagStore, partnerStore } = useStore();
  const { featureFlags } = featureFlagStore;
  const { options, setPartnerOptionLanguage } = partnerStore;
  const { passthroughParams } = options;

  const lang =
    passthroughParams && passthroughParams?.language
      ? passthroughParams.language
      : i18n.language;
  const isEnLang = i18n.language === 'en';
  const isChecked = isEnLang ? lang === 'es' : lang === 'en';

  const handleLanguageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newLanguage = isEnLang ? 'es' : 'en';
    setPartnerOptionLanguage(
      event.target.checked ? newLanguage : (i18n.language as LanguageOptions)
    );
  };

  const style = {
    marginRight: 1,
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },

    '& .MuiSvgIcon-root': {
      fill: 'transparent',
      outline: `1px solid ${theme.palette.brandGray.main}`,
    },

    '&.Mui-checked .MuiSvgIcon-root': {
      fill: theme.palette.primary.main,
      outline: `2px solid ${theme.palette.primary.main}`,
    },
  };

  if (featureFlags.enablePreferredLanguage) {
    return (
      <Box
        sx={{
          backgroundColor: theme.palette.brandGray.lighter,
          padding: '1rem 1.25rem',
          position: 'relative',
          height: '70px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                inputProps={{ 'data-cy': 'contactInfo' + 'Checkbox' } as object}
                onChange={handleLanguageChange}
                checked={isChecked}
                checkedIcon={<CheckIcon />}
                sx={style}
                disableRipple
              />
            }
            componentsProps={{
              typography: {
                color: `${theme.palette.brandGreen.dark} !important`,
                fontWeight: 600,
                marginBottom: '20px',
                fontSize: '16px',
              },
            }}
            label={t('setEs')}
          />
          <Text
            sx={{
              color: theme.palette.brandGray.darker,
              fontSize: '0.75rem',
              paddingLeft: '40px',
              marginTop: '-20px',
            }}
          >
            {t('setEsDesc')}
          </Text>
        </FormGroup>
      </Box>
    );
  }
});
